<script setup>
import { userAuthState } from "@/@core/auth"
import SurveyTable from "@/views/survey/SurveyTable.vue"
import { SurveyType } from "@/enums/survey/survey.type"

definePage({
  meta: {
    name: "Event Survey",

    // subject: "service_desk.menu",
    // action: "dashboard",
  },
})

const auth = userAuthState()
</script>

<template>
  <div class="d-flex flex-column gap-y-6">
    <!--
      <div class="d-flex gap-6">
      <VCard class="flex-grow-1">
      <VCardText>
      Filter
      </VCardText>
      </VCard>
    
      <VCard class="flex-grow-1">
      <VCardText>
      Graph
      </VCardText>
      </VCard>
      </div> 
    -->

    <!-- Table -->
    <SurveyTable :survey-type="SurveyType.EVENT" />
  </div>
</template>
